import { render, staticRenderFns } from "./UsersPrivilegeMedicalRequirementsPlan.vue?vue&type=template&id=7188e1f9&scoped=true&"
import script from "./UsersPrivilegeMedicalRequirementsPlan.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeMedicalRequirementsPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188e1f9",
  null
  
)

export default component.exports